import React from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { businessInfo } from "../data/content";

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-primary border-t border-white/10 shadow-2xl" data-testid="floating-cta">
      <div className="flex">
        <a
          href={businessInfo.phoneTel}
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-secondary text-white font-bold text-sm uppercase tracking-wider"
          data-testid="floating-cta-phone"
        >
          <Phone size={18} /> Appeler
        </a>
        <Link
          to="/contact"
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-primary text-white font-bold text-sm uppercase tracking-wider border-l border-white/10"
          data-testid="floating-cta-devis"
        >
          Devis gratuit
        </Link>
      </div>
    </div>
  );
}
